export default "__VITE_ASSET__BSRzEldF__"